<template>
  <div :class="{ map: true, active: isActive }">
    <iframe class="iframe" ref="frame" @load="handleLoadDebounced" :src="src" allowfullscreen />
    <transition name="loader">
      <div v-if="isPending" class="loader-overlay">
        <div class="loader" />
      </div>
    </transition>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

const API_KEY = 'AIzaSyArZinb2HAWCJ4YGS9WYUNx4hht5tGCooU';
const DEBOUNCE_DELAY = 1000;
const DEBOUNCE_MAPS_LOANDING_DELAY = 3000;

export default {
  data() {
    return {
      src: null,
      isActive: false,
      isPending: false,
    };
  },
  props: {
    address: {
      type: String,
      default: '',
    },
  },
  computed: {
    updateSrcDebounced() {
      return debounce(this.updateSrc, DEBOUNCE_DELAY);
    },
    handleLoadDebounced() {
      return debounce(this.handleLoad, DEBOUNCE_MAPS_LOANDING_DELAY);
    },
  },
  methods: {
    updateSrc() {
      const address = this.address ? encodeURIComponent(this.address.trim()) : null;
      const mapSrc = `https://www.google.com/maps/embed/v1/place?key=${API_KEY}&q=${address}`;
      this.isActive = false;
      if (!address || this.src === mapSrc) return;

      this.src = mapSrc;
      this.isPending = true;
    },
    handleLoad() {
      const isLoaded = this.$refs.frame && this.$refs.frame.contentWindow.window.length > 0;

      this.isActive = isLoaded;
      this.isPending = !isLoaded;
    },
  },
  watch: {
    address: {
      handler: 'updateSrcDebounced',
      immediate: true,
    },
  },
};
</script>

<style scoped src="./mapPreview.css"></style>
